import styled from 'styled-components';
import * as R from "ramda";

import { LightBtnS, PrimaryButtonS } from '../../common/Button';
import { Text } from '../../common';

import { DisplayFlexS } from '../../../../utils/stylesHelpers';
import { getThemeColor, getThemeFont, getThemeSize } from '../../../../utils/theme';

import { COMMENT_WORKFLOW_STATES } from '../../../constants/comments';

const stateToColor = R.cond([
  [R.equals(COMMENT_WORKFLOW_STATES.NEW), R.always(getThemeColor(['violet']))],
  [R.equals(COMMENT_WORKFLOW_STATES.EDITED), R.always(getThemeColor(['greyYellow']))],
  [R.equals(COMMENT_WORKFLOW_STATES.POSTED), R.always(getThemeColor(['green']))],
  [R.equals(COMMENT_WORKFLOW_STATES.DELETED), R.always(getThemeColor(['red']))],
]);

export const Nav = styled.div`
  margin-bottom: 18px;
`;

export const NavBtn = styled(LightBtnS)`
  margin-right: 10px;
  padding: 8px 20px;
  ${ ({ active }) => active && `
      color: #fff;
      background-color: #d90e4b;
  ` }
`;

export const CommentsWr = styled.div`
  max-width: 850px;
  width: 100%;
`;

export const Item = styled(DisplayFlexS)`
  padding: 20px 30px;
  margin-bottom: 3px;
  background-color: ${({ workflowState }) => workflowState === COMMENT_WORKFLOW_STATES.NEW ? '#EDEDFF' : getThemeColor([ 'white']) };
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
  border-left: 9px solid ${({ workflowState }) => stateToColor(workflowState)};
`;

export const ControlsBtns = styled(DisplayFlexS)``;

export const ControlsBtn = styled(DisplayFlexS)`
  margin-right: -12px;
`;

export const Name = styled(DisplayFlexS)`
  margin-bottom: 20px;
  color: ${getThemeColor(['gray_1'])}
`;

export const NameText = styled(Text)`
  margin: 0 10px;
  
`;

export const NameCompany = styled(Text)`
  margin-bottom: 20px;
`;

export const NameAuthor = styled(Text)``;

export const Date = styled(Text)`
  display:block;
  margin-top: 10px; 
  font-size: ${getThemeSize(['smallText'])};
`;

export const AnswerWrap = styled.div`
  width: 93%;
  display: flex;
  margin-top: 15px;
  margin-left: 7%;
  padding-left: 20px;
  padding-bottom: 5px;
  border-left: 1px solid ${({borderColor}) => getThemeColor([borderColor])};
`;

export const MoreBtn = styled(DisplayFlexS)`
  border-top: 1px solid ${getThemeColor(['grayBlue'])};
  background-color: ${getThemeColor(['white'])};
  padding: 5px;
`;

export const Total = styled.div`
  margin-top: 35px;
`;

export const HistoryLogWrap = styled(DisplayFlexS)`
  margin-bottom: 15px;
`;

export const ChangeText = styled.textarea`
  width: 100%;
  color: ${({ grayed }) => getThemeColor([grayed ? 'gray_1' : 'primary'])};
  font-size: ${getThemeSize(['normalText'])};
  font-family: ${getThemeFont(['regular'])};
  font-weight: bold;
  background-color: transparent;
  border: 0;
  pointer-events: none;
  resize: none;
  outline: none;
  ${({isEdit}) => isEdit && `
    pointer-events: auto;
  `}
`;

export const EditBtns = styled(DisplayFlexS)`
   margin-top: 20px;
   display: flex;
  //  ${({isEdit}) => isEdit && `
  //   display: flex;
  // `}
`;

export const EditBtnsCancel = styled(PrimaryButtonS)`
  max-width: 120px;
  width: 100%;
  margin-left: 15px;
`;

export const RatingWrap = styled.div`
  display: inline-block;
  span {
    line-height: 24px;
    font-size: ${getThemeSize(['bigText'])};
    vertical-align: top;
    
    &:not(:last-child) {
      img {
           margin-right: 10px;
      }
    }
  }
`;
